@for (number of [1,2,3,4,5]; track number) {
<span>
  @if (difficulty !== 0 && (difficulty % 5 === 0 || number <= difficulty % 5)) {
  <qtm-icon>
    <img
    class="icon-generic"
    src="assets/icon_fill_shield_{{ level }}.svg"
    alt="filled shield icon"
  />
  </qtm-icon>
  } @else if (difficulty >= 0) {
  <qtm-icon>
    <img
    class="icon-generic"
    src="assets/icon_empty_shield_{{ level }}.svg"
    alt="empty shield icon"
  />
  </qtm-icon>
  } @else {
  <qtm-icon>
    <img
    class="icon-generic"
    src="assets/icon_unknown_shield.svg"
    alt="unknown shield icon"
  />
  </qtm-icon>
  }
</span>
}
